import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private http: HttpClient) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = sessionStorage.getItem('token');
    const authReq = token ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req;
    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && !req.url.includes('/login') && !req.url.includes('/refresh')) {
          return this.http.post<{ token: string }>('/api/refresh', {}).pipe(
            switchMap(res => {
              sessionStorage.setItem('token', res.token);
              const retryReq = req.clone({ setHeaders: { Authorization: `Bearer ${res.token}` } });
              return next.handle(retryReq);
            }),
            catchError(err => {
              sessionStorage.removeItem('token');
              window.location.href = '/login';
              return throwError(() => err);
            })
          );
        }
        return throwError(() => error);
      })
    );
  }
}
